import moment from 'moment';
import React, { createContext, useState } from 'react';

export const ReportContext = createContext(undefined);

export const ReportContextProvider = ({ children }) => {
  const options = [
    {
      value: 'day',
      label: 'Day',
    },
    {
      value: 'month',
      label: 'Month',
    },
    {
      value: 'year',
      label: 'Year',
    },
  ];

  const [date_from, setDateFrom] = useState(
    moment().subtract(1, 'months').format('YYYY-MM-DD'),
  );

  const [date_to, setDateTo] = useState(moment().format('YYYY-MM-DD'));
  const [by_time, setByTime] = useState('day');
  const [chart, setChart] = useState('count');
  const [chart_type, setChartType] = useState('area');
  /** Commerce string order_status for report filters (docs/order-management-admin-guide.md). */
  const [reportOrderStatus, setReportOrderStatus] = useState('delivered');
  const [includeAllStatuses, setIncludeAllStatuses] = useState(true);
  const [categoryId, setCategoryId] = useState(undefined);
  const [sort, setSort] = useState('revenue');
  const [sortDir, setSortDir] = useState('desc');
  const [actual, setActual] = useState(undefined);
  const [lowThreshold, setLowThreshold] = useState(10);
  const [search, setSearch] = useState('');
  const handleByTime = (value) => {
    setByTime(value);
  };

  const handleChart = (value) => {
    setChart(value);
  };

  const handleDateRange = (dates, dateStrings) => {
    if (dates) {
      setDateFrom(dateStrings[0]);
      setDateTo(dateStrings[1]);
    }
  };

  const resetReportFilters = () => {
    setDateFrom(moment().subtract(1, 'months').format('YYYY-MM-DD'));
    setDateTo(moment().format('YYYY-MM-DD'));
    setByTime('day');
    setChart('count');
    setChartType('area');
    setReportOrderStatus('delivered');
    setIncludeAllStatuses(true);
    setCategoryId(undefined);
    setSort('revenue');
    setSortDir('desc');
    setActual(undefined);
    setLowThreshold(10);
    setSearch('');
  };

  return (
    <ReportContext.Provider
      value={{
        options,
        handleByTime,
        date_from,
        setDateFrom,
        date_to,
        setDateTo,
        by_time,
        setByTime,
        chart,
        setChart,
        handleChart,
        chart_type,
        setChartType,
        handleDateRange,
        reportOrderStatus,
        setReportOrderStatus,
        includeAllStatuses,
        setIncludeAllStatuses,
        categoryId,
        setCategoryId,
        sort,
        setSort,
        sortDir,
        setSortDir,
        actual,
        setActual,
        lowThreshold,
        setLowThreshold,
        search,
        setSearch,
        resetReportFilters,
      }}
    >
      {children}
    </ReportContext.Provider>
  );
};
